import React, { useContext } from 'react'
import { TooltipContext } from '../Tooltip'
import TooltipContentControlled from '../TooltipContentControlled'
import { TooltipContentProps } from '../TooltipContentControlled/TooltipContentControlled'

const TooltipContent = (props: TooltipContentProps): React.ReactElement => {
  const { show } = useContext(TooltipContext)

  return <TooltipContentControlled {...props} show={show} />
}

export default TooltipContent
